import { create } from 'zustand';
import type { GeoHierarchy } from '@/app/audience-builder/utils/geo-sync';
import type { IndustryHierarchy } from '@/lib/industry';
import type { UnmappedItem } from '@/app/audience-builder/services';

interface AudienceBuilderUiState {
  unmapped: UnmappedItem[];
  lastSubmittedBrief: string;
  geoHierarchy: GeoHierarchy | null;
  // Industry → Sub-industry tree (NPJB-334) — drives the dependent Sub-industry
  // dropdown + the prune-on-parent-deselect sync in the audience store.
  industryHierarchy: IndustryHierarchy | null;
  hasUserEdited: boolean;

  setUnmapped: (items: UnmappedItem[]) => void;
  setLastSubmittedBrief: (brief: string) => void;
  setGeoHierarchy: (hierarchy: GeoHierarchy) => void;
  setIndustryHierarchy: (hierarchy: IndustryHierarchy) => void;
  markUserEdited: () => void;
  clearUserEdited: () => void;
  reset: () => void;
}

export const useAudienceBuilderUiStore = create<AudienceBuilderUiState>((set, get) => ({
  unmapped: [],
  lastSubmittedBrief: '',
  geoHierarchy: null,
  industryHierarchy: null,
  hasUserEdited: false,

  setUnmapped: (unmapped) => set({ unmapped }),
  setLastSubmittedBrief: (lastSubmittedBrief) => set({ lastSubmittedBrief }),
  setGeoHierarchy: (geoHierarchy) => set({ geoHierarchy }),
  setIndustryHierarchy: (industryHierarchy) => set({ industryHierarchy }),

  markUserEdited: () => {
    if (!get().hasUserEdited) set({ hasUserEdited: true });
  },
  clearUserEdited: () => set({ hasUserEdited: false }),

  reset: () =>
    set({
      unmapped: [],
      lastSubmittedBrief: '',
      hasUserEdited: false,
    }),
}));
